import { Component, OnInit, Input } from '@angular/core';

import { EventsService } from '../../core/services/events-service/events.service';
import { Alert, days } from '../../shared';

import * as moment from 'moment';

@Component({
	selector: 'eze-registration-closing-warning',
	template: `<eze-alert *ngIf="showAlert" [alert]="alert" [disableClose]="true"></eze-alert>`,
	styleUrls: ['./registration-closing-warning.component.css']
})
export class RegistrationClosingWarningComponent implements OnInit {
	@Input() formName = '';
	alert: Alert;

	get date() {
		const date = this.eventService.getDeadline(this.formName);
		return moment(date);
	}

	get dateString(): string {
		return this.date.format('dddd MMMM Do, YYYY');
	}

	get daysLeft(): number {
		const eventTime = this.date.unix();
		const currentTime = moment().unix();
		const diffTime = eventTime - currentTime;
		const duration = moment.duration(diffTime * 1000, 'milliseconds');
		return duration.asDays();
	}

	get contextClass(): 'danger'|'warning'|'success'|'info' {
		if (this.daysLeft < 3 ) {
			return 'warning';
		} else {
			return 'info';
		}
	}

	get showAlert(): boolean {
		return this.daysLeft < 7;
	}


	constructor(private eventService: EventsService) {}

	ngOnInit() {
		this.alert = {
			message: 'The deadline for this registration form is ' + this.dateString,
			contextClass: this.contextClass,
		};
	}


}
